import React, { useState } from 'react';
import { Mail, Lock, AlertCircle, ArrowRight, Loader2 } from 'lucide-react';
import { AuthInputField } from '../AuthInputField/AuthInputField';
import './LoginForm.css';

export function LoginForm({ onSubmit, isLoading, error }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !password) return;
    onSubmit({ email, password });
  };

  return (
    <form className="auth-login-form" onSubmit={handleSubmit}>
      {error && (
        <div className="auth-form-error">
          <AlertCircle size={16} />
          <span>{error}</span>
        </div>
      )}

      <AuthInputField
        id="login-page-email"
        label="이메일"
        type="email"
        placeholder="example@aimus.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        icon={Mail}
        required
        autoComplete="email"
      />

      <AuthInputField
        id="login-page-password"
        label="비밀번호"
        type="password"
        placeholder="비밀번호를 입력하세요"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        icon={Lock}
        required
        autoComplete="current-password"
      />

      <button
        type="submit"
        className="auth-submit-btn"
        disabled={isLoading || !email || !password}
      >
        {isLoading ? (
          <>
            <Loader2 size={16} className="auth-submit-btn__spinner" />
            <span>로그인 중...</span>
          </>
        ) : (
          <>
            <span>로그인하기</span>
            <ArrowRight size={16} />
          </>
        )}
      </button>
    </form>
  );
}
